import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { englishIqItemSchema } from '../schemas';

const startEnglishIqSessionV1DataSchema = z.object({
  item: englishIqItemSchema,
  token: z.string(),
});

export type IStartEnglishIqSessionV1Data = z.infer<typeof startEnglishIqSessionV1DataSchema>;

export const startEnglishIqSessionV1ResponseSchema: z.ZodSchema<
  IAPI<IStartEnglishIqSessionV1Data>
> = createApiResponseSchema(startEnglishIqSessionV1DataSchema) as z.ZodSchema<
  IAPI<IStartEnglishIqSessionV1Data>
>;

export type IStartEnglishIqSessionV1Response = IAPI<IStartEnglishIqSessionV1Data>;
